<app-menu-common url="sales"></app-menu-common>

<div class="payer-page">
  <!-- Tous les dossiers de location d'un payeur (documentation.html#front.rental.rental-payer) -->
  <div class="toolbar-card">
    <div class="title-block">
      <div class="customer-name"><button type="button" class="party-link" (click)="openPartner(payerId)" [disabled]="!payerId" matTooltip="Fiche du tiers payeur">{{ payerName || 'Payeur n° ' + payerId }}</button></div>
      <div class="contract-line"><span>@if (withRecipient) { Dossiers de location payés par ce tiers, ou dont il est le bénéficiaire } @else { Dossiers de location payés par ce tiers }</span></div>
    </div>
    <span class="spacer"></span>
    @if (duplicates) {
      <span class="dup-chip" matTooltip="Dossiers non annulés, avec du matériel, pour un même patient et une même prise en charge Sécu : un seul dossier par patient est attendu">
        <mat-icon>warning_amber</mat-icon>{{ plural(duplicates, 'dossier en double', 'dossiers en double') }}
      </span>
    }
    <a mat-stroked-button class="hdr-btn" [routerLink]="['/common/partner', payerId]" matTooltip="Fiche du tiers payeur"><mat-icon>person</mat-icon>Fiche du tiers</a>
  </div>

  @switch (status) {
    @case ('loading') {
      <div class="page-state"><mat-progress-spinner mode="indeterminate" diameter="36" color="primary" aria-label="Lecture des dossiers"></mat-progress-spinner></div>
    }
    @case ('failed') {
      <div class="page-state">
        <mat-icon class="state-icon">error_outline</mat-icon>
        <div class="state-title">Lecture des dossiers en échec</div>
        @if (loadError) { <div class="state-sub load-error">{{ loadError }}</div> }
        <button mat-stroked-button class="hdr-btn" (click)="load()"><mat-icon>refresh</mat-icon>Réessayer</button>
      </div>
    }
    @case ('ok') {
      <div class="tiles">
        <div class="tile"><span class="tile-label">Dossiers</span><span class="tile-value">{{ shown.length }}</span>
          @if (more) { <span class="tile-note muted" matTooltip="Les dossiers suivants se lisent par « Afficher les dossiers suivants », en bas de la liste">sur {{ total }}</span> }
        </div>
        <div class="tile"><span class="tile-label">Patients</span><span class="tile-value">{{ patients }}</span></div>
        <div class="tile"><span class="tile-label">En place</span><span class="tile-value">{{ counts.inPlace }}</span></div>
        <div class="tile"><span class="tile-label">À livrer</span><span class="tile-value">{{ counts.toDeliver }}</span></div>
        <div class="tile"><span class="tile-label">Repris</span><span class="tile-value">{{ withReturned ? counts.returned : '—' }}</span>
          @if (!withReturned) { <span class="tile-note muted">non lus</span> }
        </div>
        <div class="tile">
          <span class="tile-label">À facturer <span class="tile-unit">HT</span></span>
          <span class="tile-value amount">{{ m(dueHt) }}&nbsp;€</span>
          <span class="tile-sub">
            @if (!withReturned) { <span class="nowrap muted" matTooltip="Les jours encore dus des matériels et dossiers repris ne comptent qu'une fois « Dossiers repris » coché">hors repris</span> }
            @if (more) { <span class="nowrap muted">dossiers affichés seulement</span> }
            @if (pending) { <span class="tile-wait"><mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary"></mat-progress-spinner>{{ plural(pending, 'dossier en calcul', 'dossiers en calcul') }}</span> }
            @if (creditHt !== 0) { <span class="nowrap credit">avoirs prévus : {{ m(creditHt) }}&nbsp;€</span> }
            @if (refused) { <span class="nowrap credit">{{ plural(refused, 'passage bloqué', 'passages bloqués') }}</span> }
          </span>
        </div>
      </div>

      <div class="table-card">
        <div class="table-header-bar">
          <div class="table-title"><mat-icon>folder_shared</mat-icon><span>Dossiers</span>
            @if (listLoading) { <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="Lecture des dossiers"></mat-progress-spinner> }
          </div>
          <input class="text-input search" type="search" placeholder="Patient, matériel, n°" aria-label="Rechercher un patient, un matériel, un n° de dossier" title="Patient, matériel ou n° de dossier" [ngModel]="search" (ngModelChange)="onSearch($event)" />
          <!-- Période lue en base : dossiers ouverts avant sa fin et pas entièrement repris avant son début. -->
          <div class="filters">
            <div class="date-filter" title="Dossiers en cours à un moment de la période : ouverts au plus tard le dernier jour, pas entièrement repris avant le premier">
              <span class="filter-label">Du</span>
              <app-select-date [date]="datstart" (dateChange)="dateChange($event, 'datstart')"></app-select-date>
            </div>
            <div class="date-filter">
              <span class="filter-label">Au</span>
              <app-select-date [date]="datend" (dateChange)="dateChange($event, 'datend')"></app-select-date>
            </div>
            <div class="period-presets" role="group" aria-label="Raccourcis de période">
              @for (p of periods; track p.key) {
                <button type="button" class="period-btn" [class.active]="isPeriod(p.key)" [title]="p.title" (click)="setPeriod(p.key)">{{ p.label }}</button>
              }
            </div>
          </div>
          <div class="levels" role="group" aria-label="Dossiers repris, clos ou annulés à lire aussi">
            <span class="filter-label">Dossiers</span>
            <mat-checkbox color="primary" class="level-box" [ngModel]="withReturned" (ngModelChange)="setReturned($event)" matTooltip="Dossiers dont tout le matériel est repris (BL de reprise signé) mais pas encore clos, et matériels repris des dossiers en cours : lus à la demande">repris ({{ found.returned }})</mat-checkbox>
            <mat-checkbox color="primary" class="level-box" [ngModel]="withClosed" (ngModelChange)="setClosed($event)" matTooltip="Dossiers clos : toutes leurs lignes louées et vendues closes, par le passage de facturation ou à la main ; lus à la demande">clos ({{ found.closed }})</mat-checkbox>
            <mat-checkbox color="primary" class="level-box" [ngModel]="withCanceled" (ngModelChange)="setCanceled($event)" [disabled]="!found.canceled && !withCanceled" matTooltip="Dossiers annulés : lus à la demande">annulés ({{ found.canceled }})</mat-checkbox>
          </div>
          <button mat-stroked-button class="hdr-btn" (click)="toggleAll()" [disabled]="!shown.length" [matTooltip]="allCollapsed ? 'Déplier tous les dossiers' : 'Replier tous les dossiers'">
            <mat-icon>{{ allCollapsed ? 'unfold_more' : 'unfold_less' }}</mat-icon>{{ allCollapsed ? 'Tout déplier' : 'Tout replier' }}
          </button>
          <div class="scope view-switch" role="group" aria-label="Présentation">
            <button type="button" class="scope-btn view-btn" [class.active]="display === 'table'" [attr.aria-pressed]="display === 'table'" (click)="setDisplay('table')"><mat-icon>table_rows</mat-icon>Tableau</button>
            <button type="button" class="scope-btn view-btn" [class.active]="display === 'planning'" [attr.aria-pressed]="display === 'planning'" (click)="setDisplay('planning')"><mat-icon>view_timeline</mat-icon>Planning</button>
          </div>
        </div>

        @if (hasPeriod || (!withReturned && found.returned) || (!withClosed && found.closed)) {
          <div class="filter-note">
            @if (hasPeriod) {
              <span>{{ periodText }}</span>
              <button type="button" class="link-btn" (click)="clearPeriod()">Effacer la période</button>
            }
            @if (!withReturned && found.returned) {
              @if (hasPeriod) { <span class="sep">·</span> }
              <span>{{ plural(found.returned, 'dossier repris masqué', 'dossiers repris masqués') }}</span>
              <button type="button" class="link-btn" (click)="setReturned(true)">Les afficher</button>
            }
            @if (!withClosed && found.closed) {
              @if (hasPeriod || (!withReturned && found.returned)) { <span class="sep">·</span> }
              <span>{{ plural(found.closed, 'dossier clos masqué', 'dossiers clos masqués') }}</span>
              <button type="button" class="link-btn" (click)="setClosed(true)">Les afficher</button>
            }
          </div>
        }
        @if (loadError) { <div class="filter-note error">{{ loadError }} <button type="button" class="link-btn" (click)="load()">Réessayer</button></div> }

        @if (!shown.length) {
          <div class="page-state">
            <mat-icon class="state-icon">folder_off</mat-icon>
            <div class="state-title">
              @if (listLoading) { Lecture des dossiers… }
              @else if (search) { Aucun dossier ne répond à « {{ search }} » }
              @else if (hasPeriod) { Aucun dossier {{ withReturned || withClosed ? '' : 'en cours ' }}sur cette période }
              @else { Aucun dossier de location {{ withReturned || withClosed ? '' : 'en cours ' }}pour ce payeur }
            </div>
          </div>
        } @else if (display === 'table') {
          <div class="grid">
            <div class="line entete">
              <div class="cell">Patient</div>
              <div class="cell">Matériel</div>
              <div class="cell">Livré le</div>
              <div class="cell">Repris le</div>
              <div class="cell">Facturé jusqu'au</div>
              <div class="cell num">Rang</div>
              <div class="cell">État</div>
            </div>
            @for (vm of shown; track vm.key) {
              <ng-container [ngTemplateOutlet]="head" [ngTemplateOutletContext]="{ $implicit: vm }"></ng-container>
              @if (!collapsed.has(vm.d.id)) {
                @if (vm.cycle) {
                  @for (r of vm.shownRows; track r.id) {
                    <div class="line" [class.is-returned]="!!r.returned" [title]="'Ligne #' + r.seq + ' · id ' + r.id">
                      <div class="cell">
                        @if (r.fromDossier && vm.d.recipientId) { <span class="patient from-dossier"><button type="button" class="party-link" (click)="openPartner(vm.d.recipientId, $event)" matTooltip="Fiche du tiers bénéficiaire">{{ r.patient }}</button></span> }
                        @else { <span class="patient" [class.empty]="!r.patient" [class.from-dossier]="r.fromDossier">{{ r.patient || 'Patient non renseigné' }}</span> }
                      </div>
                      <div class="cell"><span class="product">{{ r.title }}</span>@if (r.article) { <span class="article">{{ r.article }}</span> }</div>
                      <div class="cell date-cell">
                        @if (r.delivered) { {{ fr(r.delivered) }} }
                        @else if (r.planned) { <span class="muted">prévue le {{ fr(r.planned) }}</span> }
                        @else { <span class="faint">—</span> }
                      </div>
                      <div class="cell date-cell">@if (r.returned) { {{ fr(r.returned) }} } @else { <span class="faint">—</span> }</div>
                      <div class="cell date-cell">
                        @if (r.billedUntil) { {{ fr(r.billedUntil) }} } @else if (r.delivered) { <span class="muted">rien de facturé</span> }
                      </div>
                      <div class="cell num">{{ r.rank }}</div>
                      <div class="cell state-cell">
                        <span [class]="'pill ' + statusClass(r.status)" [matTooltip]="statusHint(r.status)">{{ statusLabel(r.status) }}</span>
                        @if (r.interrupted) { <span class="pill st-interrupted">{{ INTERRUPTED_BADGE }}</span> }
                        @if (r.anomalies.length) { <span class="pill pill-anomaly" [matTooltip]="anomaliesTip(r)">{{ plural(r.anomalies.length, 'anomalie', 'anomalies') }}</span> }
                      </div>
                    </div>
                  } @empty {
                    <div class="dossier-note">{{ search ? 'Aucun matériel ne répond à la recherche' : !vm.open ? 'Aucun matériel' : 'Aucun matériel en cours (les matériels repris ne sont pas lus)' }}</div>
                  }
                } @else if (vm.loading) {
                  <div class="dossier-note"><mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary"></mat-progress-spinner>Calcul du dossier…</div>
                } @else if (vm.error) {
                  <div class="dossier-note error">{{ vm.error }} <button type="button" class="link-btn" (click)="reloadCycle(vm)">Réessayer</button></div>
                }
              }
            }
          </div>
          <ng-container [ngTemplateOutlet]="moreTpl"></ng-container>
        } @else {
          <div class="plannings">
            @for (vm of shown; track vm.key) {
              <section class="dossier-planning">
                <ng-container [ngTemplateOutlet]="head" [ngTemplateOutletContext]="{ $implicit: vm }"></ng-container>
                @if (!collapsed.has(vm.d.id)) {
                  <!-- Planning lu à l'approche de l'écran : un payeur HAD a des dizaines de dossiers. -->
                  @defer (on viewport) {
                    <app-rental-payer-planning [orderId]="vm.d.id" [withClosed]="!vm.open" [state]="vm.d.state" (decided)="reloadCycle(vm)"></app-rental-payer-planning>
                  } @placeholder {
                    <div class="planning-wait"><mat-progress-spinner mode="indeterminate" diameter="24" color="primary" aria-label="Chargement du planning"></mat-progress-spinner></div>
                  }
                }
              </section>
            }
          </div>
          <ng-container [ngTemplateOutlet]="moreTpl"></ng-container>
        }
      </div>
    }
  }
</div>

<!-- En-tête d'un dossier, commun au Tableau et au Planning. -->
<ng-template #head let-vm>
  <div class="dossier-head" [id]="'dossier-' + vm.d.id" [class.canceled]="vm.d.state === 'CANCELED'">
    <button type="button" class="icon-btn" (click)="toggle(vm.d.id)" [attr.aria-expanded]="!collapsed.has(vm.d.id)"
      [attr.aria-label]="(collapsed.has(vm.d.id) ? 'Déplier' : 'Replier') + ' le dossier ' + vm.d.id"><mat-icon>{{ collapsed.has(vm.d.id) ? 'expand_more' : 'expand_less' }}</mat-icon></button>
    <a class="dossier-link" [routerLink]="['/rental', vm.d.id]" [queryParams]="dossierQuery()" matTooltip="Ouvrir la page du dossier">Dossier n°&nbsp;{{ vm.d.id }}</a>
    @if (vm.d.openedOn) { <span class="muted">ouvert le {{ fr(vm.d.openedOn) }}</span> }
    <span class="state-pill">{{ orderLabel(vm.d.state) }}</span>
    @if (vm.d.fse) { <span class="state-pill fse" matTooltip="Dossier pris en charge par la Sécu (FSE)">Sécu</span> }
    @if (categoryPill(vm); as cp) { <span class="state-pill closed" [matTooltip]="cp.tip">{{ cp.label }}</span> }
    @if (vm.d.recipientId) { <span class="benef">Bénéficiaire : <button type="button" class="party-link" (click)="openPartner(vm.d.recipientId, $event)" matTooltip="Fiche du tiers bénéficiaire">{{ vm.d.recipientName }}</button></span> }
    @if (vm.same.length) {
      <span class="dup-chip" [matTooltip]="sameTip(vm)"><mat-icon>warning_amber</mat-icon>Même patient que
        @for (x of vm.same; track x) { <a class="dup-link" [href]="'#dossier-' + x" (click)="goTo(x, $event)">n°&nbsp;{{ x }}</a> }
      </span>
    }
    <span class="spacer"></span>
    @if (vm.loading) { <mat-progress-spinner mode="indeterminate" diameter="14" strokeWidth="2" color="primary" aria-label="Calcul en cours"></mat-progress-spinner> }
    @if (vm.cycle; as c) {
      <span class="count">{{ plural(vm.rows.length, 'matériel', 'matériels') }}</span>
      @if (c.amounts?.refused) { <span class="refused" [matTooltip]="c.amounts.refused">Passage bloqué</span> }
      @else if (c.amounts?.due_ht) { <span class="due">À facturer : <b>{{ m(c.amounts.due_ht) }}&nbsp;€</b> HT</span> }
      @else { <span class="muted">Rien à facturer</span> }
    } @else {
      <span class="count">{{ plural(listedCount(vm), 'matériel', 'matériels') }}</span>
    }
  </div>
</ng-template>

<!-- Page suivante, lue en base à la demande. -->
<ng-template #moreTpl>
  @if (more) {
    <div class="more-row">
      <button mat-stroked-button class="hdr-btn" (click)="loadMore()" [disabled]="listLoading"><mat-icon>expand_more</mat-icon>Afficher les dossiers suivants</button>
      <span class="muted">{{ plural(remaining, 'dossier non affiché', 'dossiers non affichés') }}</span>
    </div>
  }
</ng-template>
